module.exports = __webpack_public_path__ + "img/huazhuangpin.7f88f580.png";